<app-header></app-header>
<main class="pages blog">
    <!-- <section class="gradient-light">
        <div class="container pt-lg-5">
            <div class="row align-items-center">
                <div class="col-md-6">
                    <h1 class="h1-title mt-3">Blog Details</h1>
                    <p class="sub-text mt-3 d-none">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,</p>
                    <div class="mt-lg-5 mt-3">
                        <button class="btn btn-success btn-lg px-5 text-uppercase" type="button" data-toggle="modal" data-target="#callBack" id="callback">REQUEST A DEMO</button>
                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="page-banner-img">
                        <img class="img-fluid w-100" alt="Online and Offline Survey" src="assets/illustrator/cookies-policy.svg">
                    </div>
                </div>
            </div>
        </div>
    </section> -->

    <section class="blog-section gradient-light py-lg-3 bg-gradient">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <nav aria-label="breadcrumb" class="pb-lg-3">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a routerLink="/blog">Blog</a></li>
                            <li class="breadcrumb-item active" aria-current="page">{{singleBlogData.title}}</li>
                        </ol>
                    </nav>
                    <article class="current-blog">
                        <img class="img-fluid w-100 img-thumbnail" *ngIF="singleBlogData.image == ''" src="assets/blog-default.jpg" alt="">
                        <img class="img-fluid w-100 img-thumbnail" src="{{server}}{{singleBlogData.image}}" alt="">
                        <h1 class="my-lg-4">{{singleBlogData.title}}</h1>
                        <div class="blog-details mb-3 d-inline-block">
                            <span class="author mr-3"><i class="fa fa-pencil-square-o mr-1"></i>{{singleBlogData.author}}</span>
                            <span class="views"><i class="fa fa-eye mr-1"></i>{{singleBlogData.view_count}}</span>
                        </div>
                        <div [innerHTML]="singleBlogData.content"></div>
                    </article>

                </div>
            </div>
        </div>
        <div class="container px-0 d-none">
            <div class="row">
                <div class="col-lg-8 offset-lg-2 mb-lg-5  fadeInUp" style="visibility: visible; animation-name: fadeInUp;">
                    <span class="meta"><strong>{{dateFormattedString}}</strong> / <span class="comments">
                    <a href="javascript:void(0)">0 comments</a></span></span>
                    <div id="respond" class="comment-respond">
                        <h3 id="reply-title" class="comment-reply-title">Leave a Reply <small><a rel="nofollow" id="cancel-comment-reply-link" href="/5-ways-to-stay-motivated-productive-this-december/#respond" style="display:none;">Cancel reply</a></small></h3>
                        <form action="https://wearewema.com/wp-comments-post.php" method="post" id="commentform" class="comment-form">
                            <p class="comment-notes">
                                <span id="email-notes">Your email address will not be published.</span> Required fields are marked <span class="required">*</span></p>
                            <p class="comment-form-comment">
                                <label for="comment">Comment</label>
                                <textarea class="form-control" id="comment" name="comment" cols="45" rows="8" maxlength="65525" required="required"></textarea>
                            </p>
                            <p class="comment-form-author">
                                <label for="author">Name <span class="required">*</span></label>
                                <input class="form-control" id="author" name="author" type="text" value="" size="30" maxlength="245" required="required">
                            </p>
                            <p class="comment-form-email">
                                <label for="email">Email <span class="required">*</span></label>
                                <input class="form-control" id="email" name="email" type="text" value="" size="30" maxlength="100" aria-describedby="email-notes" required="required">
                            </p>
                            <p class="comment-form-url">
                                <label for="url">Website</label>
                                <input class="form-control" id="url" name="url" type="text" value="" size="30" maxlength="200">
                            </p>
                            <p class="comment-form-cookies-consent">
                                <input class="mr-1" id="wp-comment-cookies-consent" name="wp-comment-cookies-consent" type="checkbox" value="yes">
                                <label for="wp-comment-cookies-consent">Save my name, email, and website in this browser for the next time I comment.</label>
                            </p>
                            <p class="form-submit text-center">
                                <input name="submit" type="submit" id="submit" class="submit btn btn-success" value="Post Comment">
                                <input type="hidden" name="comment_post_ID" value="1211" id="comment_post_ID">
                                <input type="hidden" name="comment_parent" id="comment_parent" value="0">
                            </p>
                        </form>
                    </div>
                    <!-- #respond -->
                </div>
            </div>
        </div>
    </section>

</main>
<app-footer></app-footer>